module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.DialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.DialogVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员姓名:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.BabyInfo.BabyName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员性别:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.BabyInfo.Sex))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员出生年月日:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.BabyInfo.Birthday))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在班级:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.ClassName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所所属代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.BabyAgentInfo.C_Name))])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择所属课程顾问:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.CourseAdviser))])]), _vm._v(" "), _c('h4', [_vm._v("上课情况说明")]), _vm._v(" "), _vm._l((_vm.CourseInfo), function(item) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": item.CourseName
      }
    }, [_c('span', [_vm._v(_vm._s(item.CourseNum))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.tabRadio),
      callback: function($$v) {
        _vm.tabRadio = $$v
      },
      expression: "tabRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "网络检测情况"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "家长信息"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "订单信息"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabRadio == '网络检测情况'),
      expression: "tabRadio=='网络检测情况'"
    }]
  }, [_vm._l((_vm.NetWorkCheckList), function(item, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(index + 1) + "：" + _vm._s(item.OrderCode) + "(" + _vm._s(item.CheckStatusName) + ")")])])
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.FollowList,
      "border": "",
      "router": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "跟进人",
      "prop": "FollowEmployeeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进时间",
      "prop": "FolllowTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检测进度",
      "prop": "FollowScheduleName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检测结果",
      "prop": "FollowStatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "Remark"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabRadio == '家长信息'),
      expression: "tabRadio=='家长信息'"
    }]
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.BabyParentList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "家长姓名",
      "prop": "ParentName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "家长电话",
      "prop": "ParentPhoneNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "称呼",
      "prop": "ParentNick"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否为主家长",
      "prop": "IsMainParent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabRadio == '订单信息'),
      expression: "tabRadio=='订单信息'"
    }]
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.BabyOrderList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "订单号",
      "prop": "OrderCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "prop": "OrderTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单家长",
      "prop": "UserName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单家长电话",
      "prop": "UserPhone"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单套餐",
      "prop": "PackageName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单状态",
      "prop": "OrderStatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.ProList), function(item) {
          return _c('div', [_c('div', {
            staticClass: "divTable"
          }, [_vm._v(_vm._s(item.ProName) + "*" + _vm._s(item.ProNum))])])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程情况"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.CourseList), function(item) {
          return _c('div', [_c('div', {
            staticClass: "divTable"
          }, [_vm._v(_vm._s(item.CourseName) + "*" + _vm._s(item.CourseNum))])])
        })
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("关闭")])], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-633c6ae4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Family/StudentsList/viewDialog/index.vue
// module id = 1506
// module chunks = 1